<template>
  <div class="component">
    <v-text-field v-if="mask"
      v-mask="config"
      :value="newValue"
      @input="refresh"
      :id="id"
      :counter="withCounter"
      :maxlength="max"
      :type="type === 'password' ? (showPassword ? 'text' : 'password') : type"
      :label="label"
      :placeholder="placeholder"
      @click:append="type === 'password' ? (showPassword = !showPassword) : ''"
      :prefix="prefix"
      :append-icon="
        type === 'password' ? (showPassword ? 'mdi-eye' : 'mdi-eye-off') : ''
      "
      v-bind:autocomplete="(new Date()).getTime()"
    ></v-text-field>
    <v-text-field v-else
      :value="newValue"
      @input="refresh"
      :id="id"
      :counter="withCounter"
      :maxlength="max"
      :type="type === 'password' ? (showPassword ? 'text' : 'password') : type"
      :label="label"
      :placeholder="placeholder"
      @click:append="type === 'password' ? (showPassword = !showPassword) : ''"
      :prefix="prefix"
      :append-icon="
        type === 'password' ? (showPassword ? 'mdi-eye' : 'mdi-eye-off') : ''
      "
      v-bind:autocomplete="(new Date()).getTime()"
    ></v-text-field>
  </div>
</template>

<script type="text/babel">
import { VTextField } from "vuetify/lib";
import { mask, tokens } from "vue-the-mask";

export default {
  name: "components-forms-text_field-index",
  directives: {
    mask,
  },
  props: {
    value: undefined,
    id: undefined,
    type: {
      default: "text",
    },
    label: {
      default: undefined,
    },
    mask: {
      default: undefined,
    },
    useMaskedValue: {
      default: false,
    },
    tokens: {
      type: Object,
      default: () => tokens,
    },
    characterCounter: {
      default: true,
    },
    placeholder: {
      default: undefined,
    },
    max: {
      default: undefined,
    },
    prefix: {
      default: undefined,
    },
  },
  data() {
    return {
      showPassword: false,
      newValue: undefined,
      lastValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== this.lastValue) {
        this.onChange(newValue);
      }
    },
    useMaskedValue() {
      this.refresh(this.newValue);
    },
  },
  methods: {
    onChange(value) {
      this.newValue = this.adaptValue(value);
      this.$emit("input", this.newValue);
    },
    adaptValue(val) {
      if (val === "") {
        val = undefined;
      }

      if (this.type === "number" && val) {
        var num = Number(val);
        if (!Number.isNaN(num)) {
          val = num;
        }
      }

      return val;
    },
    refresh(val) {
      let value = this.mask ? this.masker(
        val,
        this.mask,
        this.useMaskedValue,
        this.tokens
      ) : val;
      if (value !== this.lastValue) {
        this.lastValue = value;
        this.onChange(value);
      }
    },
    masker(value, mask, masked = true, tokens) {
      return Array.isArray(mask)
        ? this.dynamicMask(maskit, mask, tokens)(value, mask, masked, tokens)
        : this.maskit(value, mask, masked, tokens);
    },
    dynamicMask(maskit, masks, tokens) {
      masks = masks.sort((a, b) => a.length - b.length);
      return function (value, mask, masked = true) {
        var i = 0;
        while (i < masks.length) {
          var currentMask = masks[i];
          i++;
          var nextMask = masks[i];
          if (
            !(
              nextMask &&
              maskit(value, nextMask, true, tokens).length > currentMask.length
            )
          ) {
            return maskit(value, currentMask, masked, tokens);
          }
        }
        return ""; // empty masks
      };
    },
    maskit(value, mask, masked = true, tokens) {
      value = value || "";
      mask = mask || "";
      var iMask = 0;
      var iValue = 0;
      var output = "";
      while (iMask < mask.length && iValue < value.length) {
        var cMask = mask[iMask];
        var masker = tokens[cMask];
        var cValue = value[iValue];
        if (masker && !masker.escape) {
          if (masker.pattern.test(cValue)) {
            output += masker.transform ? masker.transform(cValue) : cValue;
            iMask++;
          }
          iValue++;
        } else {
          if (masker && masker.escape) {
            iMask++; // take the next mask char and treat it as char
            cMask = mask[iMask];
          }
          if (masked) output += cMask;
          if (cValue === cMask) iValue++; // user typed the same char
          iMask++;
        }
      }

      // fix mask that ends with a char: (#)
      var restOutput = "";
      while (iMask < mask.length && masked) {
        var cMask = mask[iMask];
        if (tokens[cMask]) {
          restOutput = "";
          break;
        }
        restOutput += cMask;
        iMask++;
      }

      return output + restOutput;
    },
  },
  computed: {
    config() {
      return {
        mask: this.mask,
        tokens: this.tokens,
        masked: this.useMaskedValue,
      };
    },
    withCounter() {
      return this.max !== undefined && this.characterCounter;
    },
  },
  created() {
    this.newValue = this.value;
  },
  mounted() {},
  beforeDestroy() {},
  mixins: [],
  components: {
    VTextField,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
